import { isTextSelection } from '@tiptap/core';
import { BubbleMenu } from '@tiptap/react';
import { useMemo, useRef } from 'react';

import Bold from './editor-buttons/Bold';
import Italic from './editor-buttons/Italic';
import Underline from './editor-buttons/Underline';
import Strikethrough from './editor-buttons/Strikethrough';
import BulletedList from './editor-buttons/BulletedList';
import Quote from './editor-buttons/Quote';
import Paragraph from './editor-buttons/Paragraph';
import Heading1 from './editor-buttons/Heading1';
import Heading2 from './editor-buttons/Heading2';
import CodeBlock from './editor-buttons/CodeBlock';
import './style.css';

const NODE_TYPES_WITHOUT_BUBBLE_MENU = ['custom-img'];

const BubbleToolbar = ({ editor }) => {
  const elementRef = useRef();
  const tippyOptions = useMemo(() => ({ duration: 100 }), []);

  if (!editor) return null;

  const shouldShow = ({ view, state, from, to }) => {
    const { doc, selection } = state;
    const { empty } = selection;

    // Sometime check for `empty` is not enough.
    // Doubleclick an empty paragraph returns a node size of 2.
    // So we check also for an empty text size.
    const isEmptyTextBlock = !doc.textBetween(from, to).length && isTextSelection(state.selection);

    // When clicking on a element inside the bubble menu the editor "blur" event
    // is called and the bubble menu item is focussed. In this case we should
    // consider the menu as part of the editor and keep showing the menu
    const isChildOfMenu = elementRef?.current?.contains(document.activeElement);

    const hasEditorFocus = view.hasFocus() || isChildOfMenu;

    if (
      !hasEditorFocus ||
      empty ||
      isEmptyTextBlock ||
      !editor.isEditable ||
      NODE_TYPES_WITHOUT_BUBBLE_MENU.includes(selection?.node?.type?.name)
    ) {
      return false;
    }

    return true;
  };

  return (
    <BubbleMenu ref={elementRef} editor={editor} tippyOptions={tippyOptions} shouldShow={shouldShow}>
      <div className="bubble-menu">
        <Bold editor={editor} />
        <Italic editor={editor} />
        <Underline editor={editor} />
        <Strikethrough editor={editor} />
        <BulletedList editor={editor} />
        <Quote editor={editor} />
        <div className="text-editor-vertical-divider" />
        <Paragraph editor={editor} />
        <Heading1 editor={editor} />
        <Heading2 editor={editor} />
        <div className="text-editor-vertical-divider" />
        <CodeBlock editor={editor} />
      </div>
    </BubbleMenu>
  );
};

export default BubbleToolbar;
